import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Client } from 'src/app/shared/models/uba/profile/model';

export interface ClientState extends EntityState<Client, string>, ActiveState {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'Client' })
export class ClientStore extends EntityStore<ClientState> {
  constructor() {
    super();
  }
}
